import { Box, HStack, Text } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FiCheck } from "react-icons/fi";

const MotionBox = motion.create(HStack);

const CopyTooltip = ({ x, y, placement }) => {
  const isTop = placement === "top";

  const animation = {
    initial: {
      opacity: 0,
      y: isTop ? -4 : 4,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.1,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      y: isTop ? -4 : 4,
      transition: { duration: 0.1 },
    },
  };

  return (
    <MotionBox
      position="absolute"
      top={`${y}px`}
      left={`${x}px`}
      style={{
        translateX: "-50%",
        translateY: isTop ? "-100%" : "0%", // ⬅️ This is what was missing
      }}
      px="2"
      py="1"
      fontSize="sm"
      borderRadius="md"
      boxShadow="md"
      pointerEvents="none"
      zIndex={9999}
      bg="green"
      color="white"
      backdropFilter="blur(18px)"
      align="center"
      gap="1.5"
      fontWeight="semibold"
      {...animation}
    >
      <FiCheck />
      <Text>Copied</Text>
    </MotionBox>
  );
};

const CopyTooltipPortal = () => {
  const [position, setPosition] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      const target = e.target.closest("[data-can-copy]");
      if (!target) return;

      const text = target.dataset.copyValue || target.innerText;
      navigator.clipboard.writeText(text.trim());

      const rect = target.getBoundingClientRect();
      const x = window.scrollX + rect.left + rect.width / 2;

      let y = 0;
      let placement = "top";

      if (rect.top < 40) {
        // Not enough space above — show below
        y = window.scrollY + rect.bottom + 8;
        placement = "bottom";
      } else {
        // Show above
        y = window.scrollY + rect.top - 8;
        placement = "top";
      }

      setPosition({ x, y, placement });

      const timer = setTimeout(() => setPosition(null), 1000);
      return () => clearTimeout(timer);
    };

    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return createPortal(
    <AnimatePresence>
      {position && (
        <CopyTooltip
          key="copy-tooltip"
          x={position.x}
          y={position.y}
          placement={position.placement}
        />
      )}
    </AnimatePresence>,
    document.body
  );
};

export default CopyTooltipPortal;
